import { buildSlice, CommonState } from '~libs/reduxUtils';
import { Worker } from '~weekly-planner/lib/common';

import { typePrefix, visualiseDistance } from '~weekly-planner/actions/visualise';

const initialState: CommonState<Worker> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
};

const slice = buildSlice<CommonState<Worker>, Worker>(typePrefix, initialState, {
  customActions: {
    clearSingleRow: (state, action) => {
      state.rows = state.rows.filter((worker) => String(worker?.id) !== String(action.payload));
    },
  },
  extraReducers: (builder) => {
    builder.addCase(visualiseDistance.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.hasLoaded = true;

      const newWorker = action.payload.data;

      const existingWorkerIndex = state.rows.findIndex((worker) => worker?.id === newWorker?.id);

      if (existingWorkerIndex >= 0) {
        state.rows[existingWorkerIndex] = newWorker;
      } else {
        state.rows.push(newWorker);
      }
    });
  },
});

export const { clear, clearSingleRow, updateParams } = slice.actions;
export default slice.reducer;
